export default __webpack_public_path__ + "static/media/hero_cover.1dfc80e3.jpg";